import { ControlledTable } from "Components";
import { SingleFormObjType } from "DataTypes/Form";
import { PreApprovedPlanListType } from "DataTypes/PatientManagement.type";
import { actionArrType, columnType } from "DataTypes/Table";

export const FormDataObj: SingleFormObjType = {
  id: "practice",
  label: "Problem",
  placeholder: "Select Problem",
  boxType: "single-select",
  boxSize: 3,
  validatetype: "dropdown",
  readOnly: false,
};

export const TableCol: () => columnType[] = () => {
  const Arr: columnType[] = [
    ControlledTable.ColumnData.ProblemNameCol("20%"),
    ControlledTable.ColumnData.VersionCol("15%"),
    ControlledTable.ColumnData.CreatedByCol("15%"),
    ControlledTable.ColumnData.CreatedAtCol("15%"),
    ControlledTable.ColumnData.StatusCol("15%"),
    ControlledTable.ColumnData.ActionCol("20%"),
  ];
  return Arr;
};

export const actionArr: (
  handleView: () => void,
  handleEdit: () => void,
  handleDelete: () => void,
  data: PreApprovedPlanListType
) => actionArrType[] = (handleEdit, handleView, handleDelete, data) => {
  const Arr: actionArrType[] = [
    ControlledTable.ActionData.editAction({ handleClick: handleEdit }),
    ...data.status == "DRAFT" ? [
      ControlledTable.ActionData.deleteAction(handleDelete)
    ] : [
      ControlledTable.ActionData.ViewCarePlanAction(
        handleView,
        "View Pre-Approved Plan"
      ),
      ControlledTable.ActionData.enableDisableAction(
        () => console.log("test"), true
      ),
    ],

  ];
  return Arr;
};

